var exports = {
  "u": "xe533113f--9754b2--filters",
  "h": "xe533113f--9754b2--all-offers-button",
};

module.exports = exports;
